import { getCordovaReadyPromise } from '@src/utils/cordovaChecker'
import { generateDeferredPromise } from '@src/utils/DeferredPomiseUtil'

const deferred = generateDeferredPromise()
// Off Android this rejects at load, before any tool asks; mark it handled so the
// browser does not report an unhandled rejection. Callers still get the rejection.
deferred.promise.catch(() => {})
declare let cordova: any

getCordovaReadyPromise().then(() => {
    console.log('ATBase: Cordova: Calling DeviceIdClient#getDeviceDetails')
    cordova.exec(
        deferred.resolve,
        deferred.reject,
        'DeviceIdClient',
        'getDeviceDetails',
        [],
    )
}, () => deferred.reject(new Error('Cordova not available: device details are unsupported on this platform')))

export async function getDeviceDetailsListener () {
    return deferred.promise
}
